var _defs, _path, _path2, _path3, _path4, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew205({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.7,8.23c0-.52-.07-1.15-.06-1.61h0c-.12.44-.28.9-.47,1.41L3.5,9.84H3.13l-.6-1.77A14.88,14.88,0,0,1,2.1,6.62h0c0,.46,0,1.09-.07,1.64l-.1,1.6H1.46l.26-3.72h.61L3,7.94c.15.46.28.87.37,1.25h0c.09-.37.23-.78.39-1.25l.66-1.8H5l.23,3.72H4.79Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.54,8.69,6.16,9.86h-.5L6.93,6.14h.58L8.78,9.86H8.26l-.4-1.17Zm1.23-.38L7.4,7.24c-.08-.24-.14-.46-.19-.68h0c-.06.22-.12.45-.19.68L6.64,8.31Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.6,6.55H8.47V6.14h2.76v.41H10.09V9.86H9.6Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.68,9.86,11.47,6.14H12L12.56,8c.16.5.3,1,.4,1.39h0c.11-.43.26-.9.43-1.38L14,6.14h.51L13.21,9.86Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 0.5,
    y: 4.53,
    width: 15,
    height: 6.94
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew205);
export default __webpack_public_path__ + "static/media/Symbolpack_New_205.01325c18d6a8b44f0e71c9450792d6e9.svg";
export { ForwardRef as ReactComponent };